import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取续费设置列表 **/
    GET_RENEW_LIST(data) {
        controller='EsRenew';
        action='GetRenewList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取续费设置详情 **/
    GET_RENEW_DETAIL(data) {
        controller='EsRenew';
        action='GetRenewDetail';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 新增续费设置 **/
    ADD_RENEW(data) {
        controller='EsRenew';
        action='AddRenew';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 删除设置 **/
    DEL_RENEW(data) {
        controller='EsRenew';
        action='DelRenew';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取续费设置信息 **/
    GET_RENEW_INFO(data) {
        controller='EsRenew';
        action='GetRenewInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 修改续费设置 **/
    EDIT_RENEW(data) {
        controller='EsRenew';
        action='EditRenew';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 修改续费设置排序 **/
    CHANGE_SORT(data) {
        controller='EsRenew';
        action='ChangeSort';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 续费设置上下架 **/
    CHANGE_SHOW(data) {
        controller='EsRenew';
        action='ChangeShow';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },
    

    /** 获取续费时间类型 **/
    GET_TIME_TYPE(data) {
        controller='EsRenew';
        action='GetTimeType';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取作用区域 **/
    GET_AREA_TYPE(data) {
        controller='EsRenew';
        action='GetAreaType';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


    //获取商品续费详情商品日志
    GET_RENEW_DETAIL_GOODS_LIST(data) {
        controller='EsRenew';
        action='GetRenewDetailList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


    //获取商品续费详情商品日志
    GET_RENEW_DETAIL_GOODS_LOG(data) {
        controller='EsRenew';
        action='GetRenewDetailGoodsLog';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


    //获取商品置顶退款信息
    GET_RENEW_DETAIL_GOODS_TOP(data) {
        controller='EsRenew';
        action='GetRenewDetailGoodsTop';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },


    //提交退订信息
    GOODS_RENEW_REFUND(data) {
        controller='EsRenew';
        action='GoodsRenewRefund';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

   
}